/* Copyright © 2023 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and */
/* matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, */
/* including without limitation, material generated from the software programs which are displayed on the screen such */
/* as icons, screen display looks, etc. */

import { Component } from '@angular/core';
import { XaccBrowseComponent } from './xacc-browse.component';

@Component({
  selector: 'xacc-browse-modal',
  templateUrl: './xacc-browse-modal.component.html',
  styleUrls: ['./xacc-browse-modal.component.less'],
  standalone: false,
})
export class XaccBrowseModalComponent extends XaccBrowseComponent {}
